import { useContext, useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import Link from "next/link";
import Image from "next/image";
//import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { IoSearchOutline } from "react-icons/io5";
import { FiShoppingCart, FiUser, FiBell } from "react-icons/fi";

//internal import
import NavbarPromo from "@layout/navbar/NavbarPromo";
import { UserContext } from "@context/UserContext";
import LoginModal from "@component/modal/LoginModal";
import CartDrawer from "@component/drawer/CartDrawer";
import { SidebarContext } from "@context/SidebarContext";
import NavbarNotice from "./NavbarNotice";
import { CartContext } from "@context/CartContext";
import NotificationSettingsModal from "@component/notifications/NotificationSettingsModal";


//popover
import { Fragment } from "react";
import { Transition, Popover, Menu } from "@headlessui/react";

//internal import
import { user } from "@utils/data";
import * as gtag from "src/lib/gtag"

const Navbar = ({ checkSearch, setChackSearch, mobileMainNavState }) => {
  const [imageUrl, setImageUrl] = useState("");
  const [searchText, setSearchText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const { toggleCartDrawer } = useContext(SidebarContext);
  const { totalItems } = useContext(CartContext);
  const router = useRouter();


  const { mobileMainNav, setMobileMainNav } = mobileMainNavState;

  const dRef = useRef();
  const formRef = useRef();
  const inRef = useRef();

  const {

    state: { userInfo },
  } = useContext(UserContext);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const [query, setQuery] = useState("");

  //Record Query entered by user
  const search = () => {
    gtag.event({
      action: "search",
      params: {
        search_term: query
      }
    })
  };

  const handleSearch = (e) => {
    setChackSearch(e.target.value);
    setQuery(e.target.value);
    search();
  };

  useEffect(() => {
    if (Cookies.get("userInfo")) {
      const user = JSON.parse(Cookies.get("userInfo"));
      setImageUrl(user.image);
    }
  }, []);

  useEffect(() => {
    if (!mobileMainNav) {
      inRef.current.focus();
    }
  }, [mobileMainNav]);
  return <>
    <CartDrawer />
    {modalOpen && (
      <LoginModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
    )}
    <NotificationSettingsModal 
      isOpen={notificationModalOpen} 
      onClose={() => setNotificationModalOpen(false)} 
    />

    <div
      className="sticky top-0 z-20 bg-black shadow-lg"
    >
      <div className="max-w-screen-2xl mx-auto px-3 sm:px-10">
        <div className="top-bar h-16 lg:h-auto flex items-center justify-between py-4 mx-auto">
          {/* Logo section */}
          <Link href="/" className="mr-3 lg:mr-8 xl:mr-10 hidden md:hidden lg:block transition-transform hover:scale-105">
            <Image
              width={145}
              height={30}
              src="/logo/logo-light.svg"
              alt="logo"
              placeholder="blur"
              blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
              style={{
                maxWidth: "100%",
                height: "auto"
              }}
              className="drop-shadow-md"
            />
          </Link>

          {/* Search bar section */}
          <div className="w-full transition-all duration-200 ease-in-out lg:flex lg:max-w-[520px] xl:max-w-[750px] 2xl:max-w-[900px] md:mx-12 lg:mx-4 xl:mx-0">
            <div className="w-full flex flex-col justify-center flex-shrink-0 relative z-30">
              <div className="flex flex-col mx-auto w-full">
                {/* Mobile search form */}
                {
                  <form
                    ref={formRef}
                    onSubmit={handleSubmit}
                    className={`${mobileMainNav && "hidden"
                      } lg:hidden relative pr-12 md:pr-14 bg-white overflow-hidden rounded-full shadow-md w-full border border-gray-200`}
                  >
                    <label className="flex items-center py-0.5 w-full">
                      <input
                        ref={inRef}
                        onChange={handleSearch}
                        value={checkSearch}
                        autoFocus
                        className="form-input w-full pl-5 appearance-none transition ease-in-out text-input text-sm font-sans rounded-full min-h-10 h-10 duration-200 bg-white focus:ring-0 outline-none border-none focus:outline-none holder-gray-500 placeholder-opacity-75"
                        placeholder="Search for products (e.g. 3x3, lube, magnetic)"
                      />
                    </label>
                    <button
                      aria-label="Search"
                      type="submit"
                      className="outline-none text-xl text-gray-400 absolute top-0 right-0 end-0 w-12 md:w-14 h-full flex items-center justify-center transition duration-200 ease-in-out hover:text-red-500 focus:outline-none"
                    >
                      <IoSearchOutline />
                    </button>
                  </form>
                }

                {/* Desktop search form */}
                {
                  <form
                    id={"searchForm"}
                    onSubmit={handleSubmit}
                    className="relative pr-12 md:pr-14 bg-white overflow-hidden rounded-full shadow-md w-full border border-gray-200 transition-all duration-300 hover:shadow-lg"
                  >
                    <label className="flex items-center py-0.5 w-full">
                      <input
                        onChange={handleSearch}
                        value={checkSearch}
                        className={`form-input w-full pl-5 appearance-none transition ease-in-out border text-input text-sm font-sans rounded-md min-h-10 h-10 duration-200 bg-white focus:ring-0 outline-none border-none focus:outline-none holder-gray-500 placeholder-opacity-75`}
                        placeholder="Search for products (e.g. 3x3, lube, magnetic)"
                      />
                    </label>
                    <button
                      aria-label="Search"
                      type="submit"
                      className="outline-none text-xl text-gray-400 absolute top-0 right-0 end-0 w-12 md:w-14 h-full flex items-center justify-center transition duration-200 ease-in-out hover:text-red-500 focus:outline-none"
                    >
                      <IoSearchOutline className="transition-transform hover:scale-110" />
                    </button>
                  </form>
                }

                {/* Mobile logo and user section */}
                {
                  <div
                    className={`${!mobileMainNav && "hidden"
                      } lg:hidden flex w-full p-3 rounded-md justify-between`}
                  >
                    <div className="mr-3 mt-1 lg:mr-12 xl:mr-12 items-center">
                      <Image
                        width={145}
                        height={30}
                        src="/logo/logo-light.svg"
                        alt="logo"
                        placeholder="blur"
                        blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        style={{
                          maxWidth: "100%",
                          height: "auto"
                        }}
                      />
                    </div>
                    <button
                      aria-label="User"
                      type="button"
                      className="nav-icon-btn text-white"
                    >
                      {imageUrl || userInfo?.image || userInfo?.email ? (
                        <Popover className="relative font-serif">
                          <Popover.Button className="group inline-flex items-center py-2 text-xs font-medium hover:text-red-500 focus:outline-none transition-all duration-300">
                            <div className="p-[0.8px] bg-gradient-to-r from-red-500 to-yellow-500 rounded-full mr-2">
                              <div className="bg-black rounded-full p-2">
                                <div className="overflow-hidden text-ellipsis w-24 sm:w-40 whitespace-nowrap ">Hi, {userInfo?.name.split(' ')[0]}!</div>
                              </div>
                            </div>

                            <Image
                              width={29}
                              height={29}
                              src={imageUrl || userInfo?.image}
                              alt="user"
                              className="bg-white rounded-full ring-2 ring-red-500"
                              placeholder="blur"
                              blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                              style={{
                                maxWidth: "100%",
                                height: "auto"
                              }}
                            />
                          </Popover.Button>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                          >
                            <Popover.Panel className="absolute z-10 -ml-1 mt-1 transform max-w-xs bg-white text-gray-800 rounded-xl shadow-xl border border-gray-100"
                              style={{ right: '30px' }}>                              <div className="rounded-xl overflow-hidden overflow-y-scroll flex-grow scrollbar-hide w-full h-full">                                <div className="relative grid gap-2 gap-y-4 px-4 py-4">
                                  {user.map((item) => (
                                    item.href === "#notification-settings" ? (
                                      <span 
                                        key={item.title}
                                        onClick={() => setNotificationModalOpen(true)}
                                        className="p-2 flex font-serif items-center rounded-md hover:bg-gray-50 w-full hover:text-red-500 transition-all duration-300 cursor-pointer"
                                      >
                                        <item.icon
                                          className="flex-shrink-0 h-4 w-4"
                                          aria-hidden="true"
                                        />
                                        <span className="inline-flex items-center justify-between ml-2 text-sm font-medium w-full hover:text-red-500">
                                          {item.title}
                                        </span>
                                      </span>
                                    ) : (
                                      <Link href={item.href} key={item.title}>
                                        <span className="p-2 flex font-serif items-center rounded-md hover:bg-gray-50 w-full hover:text-red-500 transition-all duration-300">
                                          <item.icon
                                            className="flex-shrink-0 h-4 w-4"
                                            aria-hidden="true"
                                          />
                                          <span className="inline-flex items-center justify-between ml-2 text-sm font-medium w-full hover:text-red-500">
                                            {item.title}
                                          </span>
                                        </span>
                                      </Link>
                                    )
                                  ))}
                                </div>
                              </div>
                            </Popover.Panel>
                          </Transition>
                        </Popover>
                      ) : (
                        <div
                          className="bg-gradient-to-r from-red-600 to-red-700 rounded-full p-1.5 shadow-md transition-transform hover:scale-105"
                          onClick={() => setModalOpen(!modalOpen)}
                        >
                          <FiUser className="w-5 h-5 text-white" />
                        </div>
                      )}
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>

          {/* Desktop navigation icons */}
          <div className="hidden md:hidden md:items-center lg:flex xl:block absolute inset-y-0 right-0 pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            {/* Notification bell */}
            <button
              className="hidden rounded-full p-1 text-white hover:text-red-500 focus:outline-none transition-all duration-300 transform hover:scale-110 mr-2"
              aria-label="Alert"
              title="Coming Soon!"
            >
              <FiBell className="w-6 h-6 drop-shadow-xl" />
            </button>

            {/* Shopping cart */}
            <button
              aria-label="Total"
              onClick={toggleCartDrawer}
              className="nav-icon-btn relative px-5 text-white text-2xl font-bold hover:text-red-500 transition-all duration-300 transform hover:scale-110"
            >
              <span className="absolute z-10 top-0 right-0 inline-flex items-center justify-center p-1 h-5 w-5 text-xs font-medium leading-none text-red-100 transform -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-red-600 to-red-700 rounded-full shadow-md">
                {totalItems}
              </span>
              <FiShoppingCart className="w-6 h-6 drop-shadow-xl" />
            </button>

            {/* User account/profile */}
            <button
              className="nav-icon-btn pl-5 text-white text-sm font-bold transition-all duration-300"
              aria-label="Login"
            >
              {imageUrl || userInfo?.image ? (
                <Popover className="relative font-serif">
                  <Popover.Button className="group inline-flex items-center py-2 text-sm font-medium hover:text-red-500 focus:outline-none transition-all duration-300">
                    <Image
                      width={29}
                      height={29}
                      src={imageUrl || userInfo?.image}
                      alt="user"
                      className="bg-white rounded-full min-h-{29px} min-w-{29px} ring-1 ring-red-500 shadow-md transition-transform hover:scale-110"
                      placeholder="blur"
                      blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      style={{
                        maxWidth: "100%",
                        height: "auto"
                      }}
                    />
                    <div className="flex">
                      <div className="ml-2">
                        <div className="overflow-hidden text-ellipsis w-24 whitespace-nowrap font-medium">Hi, {userInfo?.name?.split(' ')[0]}!</div>
                      </div>
                    </div>
                  </Popover.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Popover.Panel className="absolute z-10 -ml-1 mt-1 transform max-w-xs bg-white text-gray-800 rounded-xl shadow-xl border border-gray-100"
                      style={{ right: '43px' }}>                      <div className="rounded-xl overflow-hidden shadow-lg overflow-y-scroll flex-grow scrollbar-hide w-full h-full">                        <div className="relative grid gap-2 px-6 py-6">
                          {user.map((item) => (
                            item.href === "#notification-settings" ? (
                              <span 
                                key={item.title}
                                onClick={() => setNotificationModalOpen(true)}
                                className="p-2 flex font-serif items-center rounded-md hover:bg-gray-50 w-full hover:text-red-500 transition-all duration-300 cursor-pointer"
                              >
                                <item.icon
                                  className="flex-shrink-0 h-4 w-4"
                                  aria-hidden="true"
                                />
                                <span className="inline-flex items-center justify-between ml-2 text-sm font-medium w-full hover:text-red-500">
                                  {item.title}
                                </span>
                              </span>
                            ) : (
                              <Link href={item.href} key={item.title}>
                                <span className="p-2 flex font-serif items-center rounded-md hover:bg-gray-50 w-full hover:text-red-500 transition-all duration-300">
                                  <item.icon
                                    className="flex-shrink-0 h-4 w-4"
                                    aria-hidden="true"
                                  />
                                  <span className="inline-flex items-center justify-between ml-2 text-sm font-medium w-full hover:text-red-500">
                                    {item.title}
                                  </span>
                                </span>
                              </Link>
                            )
                          ))}
                        </div>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </Popover>
              ) : userInfo?.name ? (
                (<Link
                  href="/user/dashboard"
                  className="leading-none font-bold font-serif block bg-gradient-to-r from-red-500 to-red-700 rounded-full p-2 text-white h-8 w-8 flex items-center justify-center shadow-md transition-transform hover:scale-110">
                  {userInfo?.name[0]}
                </Link>)
              ) : (
                <span onClick={() => setModalOpen(!modalOpen)} className="bg-gradient-to-r from-red-500 to-red-700 rounded-full p-2 flex items-center justify-center shadow-md transition-transform hover:scale-110 cursor-pointer">
                  <FiUser className="w-5 h-5 text-white" />
                </span>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* second header */}
      <NavbarPromo />
    </div>

    <NavbarNotice />
  </>;
};
export default Navbar;
